import { render, staticRenderFns } from "./dynamic-document-signature-eventctrl-template.vue?vue&type=template&id=15f122ea&scoped=true&"
import script from "./dynamic-document-signature-eventctrl-template.vue?vue&type=script&lang=ts&"
export * from "./dynamic-document-signature-eventctrl-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f122ea",
  null
  
)

export default component.exports